/**
 * Shared "week" copy formatters (week rework — treatment 2A "explicit end
 * time" + 3C "date-range subtitle"). Weeks (formerly "seasons") end Sunday
 * 19:00 America/Los_Angeles (decision #31) — but the transitional week around
 * the boundary-alignment deploy ends at a different clock time, so both
 * formatters compute from the actual ISO timestamp via `Intl.DateTimeFormat`
 * in the `America/Los_Angeles` zone. NEVER hardcode "7:00 PM" / "Sunday".
 */

const LA_TZ = 'America/Los_Angeles';

/** "Sun Jul 12" -> weekday formatter, DST-aware via the IANA zone. */
const weekdayFmt = new Intl.DateTimeFormat('en-US', { timeZone: LA_TZ, weekday: 'short' });
const timeFmt = new Intl.DateTimeFormat('en-US', {
  timeZone: LA_TZ,
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
});
const monthFmt = new Intl.DateTimeFormat('en-US', { timeZone: LA_TZ, month: 'short' });
const dayFmt = new Intl.DateTimeFormat('en-US', { timeZone: LA_TZ, day: 'numeric' });

/**
 * "ends Sun 7:00 PM PT" — the explicit end-time badge/banner line (2A).
 * `endDate` is any ISO timestamp `SeasonService` returns (season.end_date).
 */
export function weekEndLabel(endDate: string): string {
  const d = new Date(endDate);
  return `ends ${weekdayFmt.format(d)} ${timeFmt.format(d)} PT`;
}

/**
 * "Jul 6–12" (same month) or "Jun 29 – Jul 5" (crossing a month boundary) —
 * the trophy-chip date-range subtitle (3C). Both dates are formatted in the
 * America/Los_Angeles calendar day, matching the week's own boundary zone.
 */
export function weekRangeLabel(startDate: string, endDate: string): string {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const startMonth = monthFmt.format(start);
  const endMonth = monthFmt.format(end);
  const startDay = dayFmt.format(start);
  const endDay = dayFmt.format(end);

  if (startMonth === endMonth) {
    return `${startMonth} ${startDay}–${endDay}`;
  }
  return `${startMonth} ${startDay} – ${endMonth} ${endDay}`;
}
